"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.auto.turn.detection': 'Detección automática de turno',
    'conversation.auto.turn.detection.help': 'Detener grabación automáticamente cuando se detecte silencio',
};
